<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9" @submit.prevent="validar()">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-9">
                        <h2 class="mb-0" v-if="modo == 'Creando'">Nuevo Sistema</h2>
                        <h2 class="mb-0" v-else>Modificando Sistema</h2>

                        <div class="text-end">
                            <router-link to="/sistemas" class="btn btn-outline-primary text-nowrap">Regresar</router-link>
                        </div>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-3">
                        <div class="d-flex">
                            <button type="submit" class="btn btn-primary w-100 text-nowrap">Publicar sistema</button>
                        </div>
                    </div>
                    <div class="alert alert-danger" v-if="msg_err" role="alert">
                        {{msg_err}}
                    </div>
                </div>
                <div class="row g-5">
                    <div class="col-xl-12">
                        <div class="row gx-3 gy-4">
                            <div class="col-sm-6 col-md-12">
                                <div class="form-floating">
                                    <input class="form-control" v-model="sistema.nombre" type="text" placeholder="nombre del sistema" />
                                    <label for="floatingEventInput">Nombre</label>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input class="form-control" v-model="sistema.numero" type="text"  />
                                    <label for="floatingEventInput">Número</label>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <select class="form-select" v-model="sistema.desarrollo" >
                                        <option value="" disabled selected="selected">Seleccionar...</option>
                                        <option value="Windev">Windev</option>
                                        <option value="Webdev">Webdev</option>
                                        <option value="Windev Mobile">Windev Mobile</option>
                                        <option value="Vue">Vue</option>
                                    </select>
                                    <label for="floatingSelectTask">Desarrollo</label>
                                </div>
                            </div>
                          
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="border-bottom mb-6">
                            <div class="form-floating">
                                <select  class="form-control" v-model="sistema.activado">
                                    <option value="1">Activo</option>
                                    <option value="0">Inactivo</option>
                                </select>
                                <label for="floatingEventInput">Estatus</label>
                            </div>
                           
                        </div>
                        <div class="border-bottom mb-6">
                            <div class="form-floating">
                                <select  class="form-control" v-model="sistema.bloqueado">
                                    <option value="1">Bloqueado</option>
                                    <option value="0">Desbloqueado</option>
                                </select>
                                <label for="floatingEventInput">Actividad</label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
  </template>
  
  <script>
  // @ is an alias to /src
  import SideBar from '@/components/SideBarNav.vue'
  import TopBar from '@/components/TopBarNav.vue'
  import axios from 'axios'
  
  export default {
    name: 'CrearSistemaView',
    components:{SideBar,TopBar},
    data(){
        return{
            sistema:{},
            msg_err:'',
            modo: (this.$route.params.id > 0 ? 'Modificando' : 'Creando'),
        }
    },
    created(){
        if(this.modo == 'Modificando') this.getData()
    },
    methods:{
        validar(){
            if(!this.sistema.nombre){
                this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: 'Debe asignar un nombre al Sistema',
                        type: 'error'
                    });
            }else{
                this.setSistemas()
            }
        },
        setSistemas(){
            axios.post(this.$url+(this.modo == 'Creando' ? '/sistema' : '/sistema/'+this.$route.params.id),this.sistema,{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
              
                if(res.data.message){
                    this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: res.data.message,
                        type: 'error'
                    });
                }else{
                    this.$router.push({name: 'sistemas'})
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: err.response.data.message,
                        type: 'error'
                    });
            })
        },
        getData(){
            axios.get(this.$url+'/sistema/'+this.$route.params.id,{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                if(res.data.message){
                    this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: res.data.message,
                        type: 'error'
                    });
                }else{
                    this.sistema = res.data
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: err.response.data.message,
                        type: 'error'
                    });
            })
        }
    }
  }
  </script>
  